var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineHeartCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.42 18.16c-2.15-.73-5.56-3.35-5.56-7.25 0-2.08 1.68-3.77 3.75-3.77.9 0 1.73.31 2.4.87.67-.56 1.51-.87 2.39-.87 2.07 0 3.75 1.69 3.75 3.77 0 3.89-3.41 6.51-5.57 7.25-.17.06-.38.09-.58.09-.21 0-.41-.03-.58-.09zm-4.07-7.24c0 3.49 3.37 5.43 4.55 5.83.04.01.14.01.18 0 1.18-.4 4.55-2.34 4.55-5.83 0-1.25-1.01-2.27-2.25-2.27-.7 0-1.37.34-1.79.91-.28.38-.92.38-1.2 0a2.18 2.18 0 0 0-1.79-.91c-1.24 0-2.25 1.02-2.25 2.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHeartCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-heart-circle.1d8ed39e68c529b6284f2cfbfb19ad76.svg";
export { ForwardRef as ReactComponent };